import React from 'react';

export default function AkoyaComplete({
  fiId,
  handleNextClick,
}) {
  setTimeout(() => handleNextClick(), 6000);
  return (
    <div>
      <div>
        Your accounts with&nbsp;
        { fiId }
        &nbsp;bank have been successfully shared.
      </div>
      <div>
        You will be redirected to the next step in a moment.
      </div>
    </div>
  );
}
